import AppConstants from "constants/AppConstants";

export const addNRPageAction = (
  actionName: string,
  featureName: string,
  customAttributes: Record<string, any> = {}
) => {
  const env = process.env.REACT_APP_NEW_RELIC_ENV || "unknown";
  const fullActionName = `${actionName}-${env}`;

  if (window.newrelic) {
    // Filter out reserved keys from customAttributes
    const reservedKeys = ["featureName", "country", "username", "timestamp"];
    const sanitizedCustomAttributes = Object.keys(customAttributes).reduce(
      (acc, key) => {
        if (!reservedKeys.includes(key)) {
          acc[key] = customAttributes[key];
        }
        return acc;
      },
      {} as Record<string, any>
    );
    window.newrelic.addPageAction(fullActionName, {
      ...sanitizedCustomAttributes, // Spread custom attributes first
      featureName,
      country: sessionStorage.getItem(AppConstants.COUNTRY_CODE),
      username: (sessionStorage.getItem("username") ?? "").split("@")[0] || null,
      timestamp: Date.now(),
    });
  }
};
